const Handlebars = require('handlebars');

import templateFeaturedProject from "../../templates/projects/featured.handlebars";
import templateProjectsList from "../../templates/projects/list.handlebars";
import templateSingleProject from "../../templates/projects/single.handlebars";

function CaseStudies() {
    const API_URL = 'https://corpo.agencijaepic.si/api/collections/projects'

    if (document.getElementById('projects-list')) {
        fetch(`${API_URL}?include=image,tags,categories`)
            .then(response => response.json())
            .then(data => {

                const projects = data.data.map(item => ({
                    code: item.attributes.code,
                    title: item.attributes.title,
                    url: item.attributes.value.url.replace(/^https?:\/\//, ''),
                    description: item.attributes.description,
                    attributes: item.attributes,
                    properties: item.attributes.value.properties,
                    link: item.links.self,
                    image: item.includes.image,
                    video: item.attributes.value.video,
                    tasks: item.attributes.value.tasks,
                    tags: item.includes.tags,
                    categories: item.includes.categories.length > 0 ? item.includes.categories[item.includes.categories.length - 1] : null,
                    is_featured: (item.attributes.value.featured === "1"),
                    review: {
                        author: {
                            name: item.attributes.value.author,
                            position: item.attributes.value.position,
                            profile: item.attributes.value.authorImage,
                        },
                        content: item.attributes.value.review,
                    }
                }));

                const featuredProject = projects.find(item => item.is_featured === true);
                console.log(featuredProject)

                document.getElementById('featured-project').innerHTML = templateFeaturedProject({ featuredProject });
                document.getElementById('projects-list').innerHTML = templateProjectsList({ projects });

            })
            .catch(error => console.error('Error fetching projects:', error));
    }
}
export default CaseStudies